if (!customElements.get('accessories-shop-by')) {
  class AccessoriesShopBy extends HTMLElement {
    connectedCallback() {
      if (this._accShopByReady) return;
      this._accShopByReady = true;

      this.tabs = Array.from(this.querySelectorAll('[data-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-panel]'));
      this.tagsContainer = this.querySelector('[data-tags-container]');
      this.modelSection = this.querySelector('[data-model]');
      this._onVisibilityUpdate = this.applyAllVisibility.bind(this);

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', this.onTabClick.bind(this));
      });

      this.bindBlocks('product');
      this.bindBlocks('category');
      this.bindCategoryFilters();

      document.addEventListener(
        window.AccAccessoriesVisibility?.EVENT || 'acc-accessories-visibility-update',
        this._onVisibilityUpdate
      );

      // Initial state: no product block selected, all accessories cards visible
      this.clearModelTags();
      this.applyAllVisibility();

      this.syncProductOnlySections();
    }

    applyAllVisibility() {
      this.applyAccessoriesFilter();
      this.applyCategoryGroupFilter(this.getActiveCategoryGroup());
      this.applyCategoryFilter(this.getActiveCategoryTag());
    }

    getActiveCategoryBlock() {
      return this.querySelector('[data-panel="category"] [data-block].is-active');
    }

    getActiveCategoryGroup() {
      const active = this.getActiveCategoryBlock();
      return active ? (active.getAttribute('data-collection-group') || '').trim() : '';
    }

    applyCategoryGroupFilter(activeGroup) {
      const group = activeGroup || '';
      this.querySelectorAll('[data-category-products-group]').forEach((el) => {
        if (!group) {
          el.removeAttribute('hidden');
        } else if (el.getAttribute('data-category-products-group') === group) {
          el.removeAttribute('hidden');
        } else {
          el.setAttribute('hidden', '');
        }
      });
    }

    getActiveCategoryTag() {
      const active = this.categoryFilters?.find((btn) => btn.classList.contains('is-active'));
      return active ? (active.getAttribute('data-filter-tag') || '').toLowerCase().trim() : '';
    }

    disconnectedCallback() {
      this._accShopByReady = false;
      if (this._onVisibilityUpdate) {
        document.removeEventListener(
          window.AccAccessoriesVisibility?.EVENT || 'acc-accessories-visibility-update',
          this._onVisibilityUpdate
        );
      }
    }

    cardPassesSearch(card) {
      var visibility = window.AccAccessoriesVisibility;
      if (!visibility || !visibility.getSearchQuery || !visibility.cardMatchesSearch) return true;
      return visibility.cardMatchesSearch(card, visibility.getSearchQuery());
    }

    normalizeHandle(value) {
      return String(value || '')
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
    }

    getActiveProductBlock() {
      return this.querySelector('[data-panel="product"] [data-block].is-active');
    }

    applyAccessoriesFilter() {
      const cards = document.querySelectorAll(
        '[data-acc-shop-by-product-only] .main_accessories'
      );
      const activeBlock = this.getActiveProductBlock();

      cards.forEach((el) => {
        let passesFilter = true;

        if (activeBlock) {
          const filterType = this.normalizeHandle(
            activeBlock.getAttribute('data-block-filter-type')
          );

          if (filterType && filterType !== 'all') {
            const dataType = this.normalizeHandle(el.getAttribute('data-type'));
            const dataType2 = this.normalizeHandle(el.getAttribute('data-type-2'));
            const activeTagEl = this.tagsContainer?.querySelector('.acc-tag.is-active');
            const isAllModelTag =
              !activeTagEl || activeTagEl.classList.contains('acc-tag--all');
            const modelTag = isAllModelTag
              ? ''
              : this.normalizeHandle(activeTagEl.textContent);

            passesFilter = false;
            if (dataType === filterType) {
              passesFilter = isAllModelTag || dataType2 === modelTag;
            }
          }
        }

        const passesSearch = this.cardPassesSearch(el);

        if (passesFilter && passesSearch) {
          el.removeAttribute('hidden');
        } else {
          el.setAttribute('hidden', '');
        }
      });

      window.AccAccessoriesVisibility?.updateProductCounts?.();
    }

    syncProductOnlySections() {
      const activeTab = this.tabs.find((t) => t.classList.contains('is-active'));
      const tabName = activeTab ? activeTab.dataset.tab : 'product';
      const isProductTab = tabName === 'product';
      document.querySelectorAll('[data-acc-shop-by-product-only]').forEach((el) => {
        if (isProductTab) {
          el.removeAttribute('hidden');
        } else {
          el.setAttribute('hidden', '');
        }
      });
    }

    bindCategoryFilters() {
      this.categoryFilters = Array.from(this.querySelectorAll('[data-category-filter]'));
      this.productsWrap = this.querySelector('[data-products-wrap]');
      this.productCards = this.productsWrap
        ? Array.from(this.productsWrap.querySelectorAll('[data-product-card]'))
        : [];
      this.noResultsEl = this.querySelector('[data-no-results]');

      this.categoryFilters.forEach((btn) => {
        btn.addEventListener('click', this.onCategoryFilterClick.bind(this));
      });
    }

    onCategoryFilterClick(event) {
      const btn = event.currentTarget;
      const wasActive = btn.classList.contains('is-active');

      this.categoryFilters.forEach((b) => {
        b.classList.remove('is-active');
        b.setAttribute('aria-pressed', 'false');
      });

      if (wasActive) {
        // Toggle off — no filter active, show all products
        this.applyCategoryFilter('');
        return;
      }

      btn.classList.add('is-active');
      btn.setAttribute('aria-pressed', 'true');

      const tag = (btn.getAttribute('data-filter-tag') || '').toLowerCase().trim();
      this.applyCategoryFilter(tag);
    }

    isCategoryProductCardVisible(card) {
      const group = card.closest('[data-category-products-group]');
      if (group && group.hasAttribute('hidden')) return false;
      return true;
    }

    applyCategoryFilter(tag) {
      let visibleCount = 0;
      this.productCards.forEach((card) => {
        const cardTags = (card.getAttribute('data-product-tags') || '').split('|');
        const passesFilter = !tag || cardTags.indexOf(tag) !== -1;
        const passesSearch = this.cardPassesSearch(card);
        const passesGroup = this.isCategoryProductCardVisible(card);
        const show = passesGroup && passesFilter && passesSearch;

        card.hidden = !show;
        if (show) visibleCount += 1;
      });

      if (this.noResultsEl) {
        this.noResultsEl.hidden = visibleCount > 0 || this.productCards.length === 0;
      }
    }

    bindBlocks(type) {
      const panel = this.querySelector('[data-panel="' + type + '"]');
      if (!panel || panel.dataset.blocksBound === 'true') return;
      panel.dataset.blocksBound = 'true';

      panel.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-block]');
        if (!btn || !panel.contains(btn)) return;

        if (btn.tagName === 'A' && type === 'category') {
          this.selectBlock(btn, type);
          return;
        }

        e.preventDefault();
        this.selectBlock(btn, type);
      });
    }

    onTabClick(event) {
      const tab = event.currentTarget;
      const tabName = tab.dataset.tab;
      this.tabs.forEach((t) => {
        const active = t.dataset.tab === tabName;
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      this.panels.forEach((panel) => {
        const active = panel.dataset.panel === tabName;
        if (active) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });
      this.syncProductOnlySections();
      if (tabName === 'product') {
        this.applyAccessoriesFilter();
      }
    }

    selectBlock(btn, type) {
      const panel = btn.closest('[data-panel]');
      if (!panel) return;

      const wasActive = btn.classList.contains('is-active');

      panel.querySelectorAll('[data-block]').forEach((b) => {
        b.classList.remove('is-active');
        if (b.hasAttribute('aria-pressed')) b.setAttribute('aria-pressed', 'false');
      });

      if (wasActive) {
        // Toggle off — no block selected
        if (type === 'product') {
          this.clearModelTags();
          this.applyAccessoriesFilter();
        } else if (type === 'category') {
          this.applyCategoryGroupFilter('');
          this.applyCategoryFilter(this.getActiveCategoryTag());
        }
        btn.setAttribute('aria-pressed', 'false');
        return;
      }

      btn.classList.add('is-active');
      if (btn.hasAttribute('aria-pressed')) btn.setAttribute('aria-pressed', 'true');

      if (type === 'product') {
        this.renderTagsFor(btn);
        this.applyAccessoriesFilter();
      } else if (type === 'category') {
        this.applyCategoryGroupFilter(btn.getAttribute('data-collection-group') || '');
        this.applyCategoryFilter(this.getActiveCategoryTag());
      }
    }

    clearModelTags() {
      if (this.tagsContainer) this.tagsContainer.innerHTML = '';
      if (this.modelSection) this.modelSection.setAttribute('hidden', '');
    }

    readBlockModelOptions(btn) {
      let raw = btn.getAttribute('data-block-tags');

      // Legacy markup: <script type="application/json" data-block-tags>"All,GL9K,..."</script>
      if (!raw) {
        const scriptEl = btn.querySelector('script[data-block-tags]');
        if (scriptEl) {
          raw = (scriptEl.textContent || '').trim();
          try {
            const parsed = JSON.parse(raw);
            if (typeof parsed === 'string') raw = parsed;
            else if (Array.isArray(parsed)) {
              const options = parsed.map((s) => String(s || '').trim()).filter(Boolean);
              return options.length ? options : ['All'];
            }
          } catch (err) {
            // use raw text as comma-separated list
          }
        }
      }

      if (!raw) return ['All'];
      const options = String(raw)
        .split(',')
        .map((s) => s.trim())
        .filter(Boolean);
      return options.length ? options : ['All'];
    }

    renderTagsFor(btn) {
      if (!this.tagsContainer) return;

      const options = this.readBlockModelOptions(btn);
      const blockLink = btn.dataset.blockLink || '';
      const allLabel = options[0] || 'All';
      const items = [{ label: allLabel, url: blockLink, isAll: true }];

      options.slice(1).forEach((label) => {
        items.push({ label: label, url: '', isAll: false });
      });

      this.tagsContainer.innerHTML = '';

      if (this.modelSection) this.modelSection.removeAttribute('hidden');

      items.forEach((item, index) => {
        const el = item.url
          ? document.createElement('a')
          : document.createElement('button');
        el.className = 'acc-tag' + (item.isAll ? ' acc-tag--all' : '');
        el.textContent = item.label;
        if (item.url) {
          el.setAttribute('href', item.url);
        } else {
          el.setAttribute('type', 'button');
        }
        if (index === 0) el.classList.add('is-active');
        el.addEventListener('click', this.onTagClick.bind(this));
        this.tagsContainer.appendChild(el);
      });
    }

    onTagClick(event) {
      event.preventDefault();
      const target = event.currentTarget;
      const wasActive = target.classList.contains('is-active');

      if (this.tagsContainer) {
        this.tagsContainer.querySelectorAll('.acc-tag').forEach((t) => t.classList.remove('is-active'));
      }

      if (wasActive) {
        const allTag = this.tagsContainer?.querySelector('.acc-tag--all');
        if (allTag && !target.classList.contains('acc-tag--all')) {
          allTag.classList.add('is-active');
        }
        this.applyAccessoriesFilter();
        return;
      }

      target.classList.add('is-active');
      this.applyAccessoriesFilter();
    }
  }

  customElements.define('accessories-shop-by', AccessoriesShopBy);
}
